import React from "react";
import Meta from "../components/global/meta";

const ProductPortal = () => {
  return (
    <div className="productPortal">
      <Meta title="Product Portal" type="page" />
      <iframe
        title="Product Portal"
        className="productPortalIframe"
        src="//portal.productboard.com/rmkqmfjkrqngs5sz6phyaah6"
        frameBorder="0"
        width="100%"
      />
    </div>
  );
};

export default ProductPortal;
